/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateSettingsScheduleApiArg, WorkingScheduleBody } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateSettingsSchedule: build.mutation<WorkingScheduleBody, UpdateSettingsScheduleApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/settings/master/schedule`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateSettingsScheduleApi };
export const { useUpdateSettingsScheduleMutation } = injectedRtkApi;
